import * as QuestionnaireApi from '@/api/questionnaire'

export default function useChat() {
  const getQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.getQuestionnaire(payload)
    return res
  }
  const getQuestionnaireList = async (payload) => {
    const res = await QuestionnaireApi.getQuestionnaireList(payload)
    return res
  }
  const fillQuestionnaire = async (payload) => {
    const res = await QuestionnaireApi.fillQuestionnaire(payload)
    return res
  }

  const setContactInfo = async (payload) => {
    const res = await QuestionnaireApi.setContactInfo(payload)
    return res
  }
  const uploadFile = async (payload) => {
    const res = await QuestionnaireApi.uploadFile(payload)
    return res
  }
  const getFillList = async (payload) => {
    const res = await QuestionnaireApi.getFillList(payload)
    return res
  }
  const getFillInfo = async (payload) => {
    const res = await QuestionnaireApi.getFillInfo(payload)
    return res
  }
  const confirm = async (payload) => {
    const res = await QuestionnaireApi.confirm(payload)
    return res
  }

  return {
    getQuestionnaire,
    fillQuestionnaire,
    setContactInfo,
    getFillList,
    uploadFile,
    confirm,
    getFillInfo,
    getQuestionnaireList
  }
}
